import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CampaignItemDto } from '@api/Api';
import useOnboardingProcess from '@hooks/useOnboardingProcess';
import { useCurrentWorkspace } from '@hooks/workspace';

import CampaignCreationStep from './CampaignCreationStep';
import InviteToCampaignStep from './InviteToCampaignStep';

type CampaignCreationOnboardingProps = {
  onCloseModal: () => void;
};

export default function CampaignCreationOnboarding({
  onCloseModal
}: CampaignCreationOnboardingProps) {
  const [currentWorkspace] = useCurrentWorkspace(false);
  const { onStartTour, onCompleteStep } = useOnboardingProcess();
  const navigate = useNavigate();
  const [step, setStep] = useState<'campaign' | 'invite'>('campaign');
  const [campaign, setCampaign] = useState<CampaignItemDto>();

  const onClose = (campaignId?: string) => {
    if (!campaignId) {
      onCloseModal();
      return;
    }
    navigate(
      `/campaigns/single/${campaignId}?startTour=${
        currentWorkspace?.role === 'workspace://contributor'
          ? 'create-campaign'
          : 'empty-files'
      }`
    );
    onStartTour({ type: undefined });
    onCompleteStep({ type: 'create-campaign', hideCongrats: true });
    onCloseModal();
  };

  if (step === 'invite' && campaign) {
    return <InviteToCampaignStep onCloseModal={onClose} campaign={campaign} />;
  }

  return (
    <CampaignCreationStep
      onCloseModal={onClose}
      setStep={setStep}
      setCampaign={setCampaign}
    />
  );
}
